import { Injectable } from '@angular/core';
import { Md5 } from 'ts-md5/dist/md5';

@Injectable()
export class EncryptService {
  constructor(){}

  encMd5(str : string){
    let encrytMd5 = new Md5();
    return encrytMd5.appendStr(str).end();
  }
}



// WEBPACK FOOTER //
// /Users/jihun.lee/Work/git-repos/client-accounting-intra-web/src/app/encrypt/encrypt-util.ts